import { render, staticRenderFns } from "./BtnWhatsapp.vue?vue&type=template&id=522bcea4&scoped=true&"
import script from "./BtnWhatsapp.vue?vue&type=script&lang=js&"
export * from "./BtnWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./BtnWhatsapp.vue?vue&type=style&index=0&id=522bcea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522bcea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VIcon,VScaleTransition})
